import { useState } from "react";
import {AiOutlineClose,AiOutlineMenu} from "react-icons/ai"

const Navbar = () => {
  const [isopen, setIsopen] = useState(false);
  const [active, setActive] = useState("");
  const handleClick = () => {
    setIsopen((prevopen) => !prevopen);
  };
  return (
    <div className="flex justify-between items-center z-10 py-4 px-10 bg-black fixed top-0 w-full">
      <h1 className="uppercase text-3xl font-bold text-green-400 ">Scribes.</h1>
      <div>
        <ul className="hidden md:flex gap-4 text-green-400 ">
          <li>Home</li>
          <li>About</li>
          <li>Reception</li>
          <li className="tranform animate-pulse duration-500 bg-white p-1 px-2 text-black rounded">Get Started</li>
        </ul>
        <div onClick={handleClick} className="block text-white md:hidden">
          {isopen ? <AiOutlineClose size={20}/>: <AiOutlineMenu size={20} className="animate-pulse"/>}
        </div>
      </div>
      <ul
        className={
          isopen
            ? "gap-4 fixed bg-white w-[60%] h-full text-green-600 top-0 left-0 ease-in-out duration-500 flex flex-col text-center md:hidden"
            : "fixed left-[-100%]"
        }
      >
        <a href="#about" onClick={()=>setActive("#about")} className={active === "#about" ? "text-white bg-[green]":""}>
          <li onClick={handleClick} className="border-b border-b-[gray] py-4 px-2 bg-inherit w-full">
            Home
          </li>
        </a>
        <a href="#analytics" onClick={()=>setActive("#analytics")} className={active === "#analytics" ? "text-white bg-[green]":""}>
          <li onClick={handleClick} className="border-b border-b-[gray] py-4 px-2 bg-inherit">
            About
          </li>
        </a>
        <li className="border-b border-b-[gray] py-4 px-2">Reception</li>
        <li className="border-b border-b-[gray] py-4 px-2 ">Get Started</li>
      </ul>
    </div>
  );
};
export default Navbar;
